export interface ScopeCopy {
  label: string;
  title: string;
  heroTagline: string;
  projectTagline: string;
  metaTitle: string;
  metaDescription: string;
}

export const SCOPE: ScopeCopy = {
  label: 'Oregon Truffle Routes',
  title: 'Oregon truffle weekends',
  heroTagline:
    'Plan Oregon truffle weekends around the few things that matter: the right forest outing, the right dinner, and a hotel that fits the route.',
  projectTagline: 'Oregon truffle weekends, city-base forays, events, dinners, and places to stay.',
  metaTitle: 'Truffle Hunting Oregon | Oregon Weekend Guide',
  metaDescription:
    'An Oregon truffle guide focused on verified outings, truffle dinners, boutique stays, and seasonal trip planning across Portland, Willamette Valley, Eugene, and Corvallis.',
};
